import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteWarehouseApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteWarehouse = createAsyncThunk('deleteWarehouse', async (payload) => {
  return await deleteWarehouseApi(payload);
});

const deleteWarehouseSlice = createSlice({
  name: 'deleteWarehouse', // Unique Name
  initialState,
  reducers: {
    deleteWarehouseReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteWarehouse.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteWarehouse.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteWarehouse.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteWarehouseReset } = deleteWarehouseSlice.actions;

export default deleteWarehouseSlice.reducer;
